import {DojoDeshi} from '../DojoDeshi.js';
import {DojoTemplates} from '../DojoTemplates.js';
import {Eventify} from '../Eventify.js';

export class StudentAttendanceCard {
	static hasParent(el, parent) {
		if (!el) return false;
		if (el==parent) return true;
		return StudentAttendanceCard.hasParent(el.parentNode, parent);
	}
	constructor(parent, classRecordId, sam, attendanceList) {
		this.sam = sam;
		this.sam.changed.add(this.attendanceChanged, this);
		this.classRecordId = classRecordId;
		this.attendanceList = attendanceList;

		[this.el, this.$] = DojoTemplates(`classrecord_student_attendance/StudentAttendanceCard`);
		Eventify(this.el, {
			'click': evt => {
				// prevent the click on the EditLink from registering as a change of
				// attendance status.
				if (StudentAttendanceCard.hasParent(evt.target, this.$.EditLink)) return;
				// Update the server then update our model
				let i = (this.attendanceIndex+1) % this.attendanceList.length;
				let attendanceType = this.attendanceList[i];

				DojoDeshi.instance().RPC().SetStudentClassRecordAttendanceType(
					this.classRecordId,
					this.sam.Student.Id,
					attendanceType.Id
				).then(
					()=>{
						this.attendanceIndex=i;
						this.sam.setAttendance(attendanceType);
					}
				).catch( (err)=> {
					console.error(err);
				});
			}
		}, this);

		this.$.Name.textContent = `${sam.Student.Firstname} ${sam.Student.Surname}`
		this.$.EditLink.setAttribute(`href`, `/students/edit/${sam.Student.Id}`);
		this.attendanceChanged(sam.Student, sam.Attendance);
		parent.appendChild(this.el);
	}
	attendanceChanged(student, attendance, src) {
		if (src==this) return;
		this.$.Attendance.textContent = attendance.Name;

		for (let i=0; i<this.attendanceList.length; i++) {
			let at = this.attendanceList[i];
			if (at.Id == attendance.Id) {
				this.attendanceIndex = i;
				break;
			}
		}
		this.$.StyleDiv.style.backgroundColor = attendance.Color;
	}
}
